import React from 'react';
import { motion } from 'framer-motion';
const results = [{
  image: 'https://cdn.magicpatterns.com/uploads/dXztQoh8BFVoy8MAFv4cxQ/kbella-before-after-1.jpg'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/wQTSmRYwbc35xefHBjffG2/kbella-before-after-2.jpg'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/k9EHt8VwqybSSG961rAQQR/kbella-before-after-3.jpg'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/oEmGGyNyDp6sz5KVDbxdG6/kbella-before-after-4.jpg'
}];
export function BeforeAfter() {
  return <section className="py-20 md:py-32 relative overflow-hidden bg-brand-blush" data-id="element-13">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-brand-charcoal mb-4" data-id="element-16">
            Real Results, Real Confidence
          </h2>
          <p className="text-lg text-brand-charcoal/70 max-w-2xl mx-auto" data-id="element-17">
            See the transformations our clients love.
          </p>
          <div className="w-16 h-1 bg-brand-teal mx-auto mt-6" data-id="element-18"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-19">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-20">
              <div className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-100" data-id="element-21">
                <img src={result.image} alt="Before and after treatment result" className="w-full h-auto object-contain" data-id="element-22" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}